import PaymentComponent from "./PaymentComponent";
export default PaymentComponent;
